import LayoutContext, { useInternalLayoutContext } from '../context/layout-context';

const LayoutProvider = ({ children }) => {
  const context = useInternalLayoutContext();
  return <LayoutContext.Provider value={context}>{children}</LayoutContext.Provider>;
};

export default LayoutProvider;
